import React, { useState } from 'react';
import { HiInformationCircle } from 'react-icons/hi';

import { ReactComponent as TipBalloonArrowIcon } from '../../assets/icons/tip-balloon-arrow.svg';

import { TipContainer, TipInformationsBalloon, TipInformationBalloonArrow } from './styles';

export default function Tip({ informations }) {
  const [isHovered, setIsHovered] = useState(false);

  const toggleMouseHover = () => {
    setIsHovered((prevState) => !prevState);
  };

  return (
    <TipContainer onMouseOver={toggleMouseHover} onMouseOut={toggleMouseHover}>
      <HiInformationCircle size={16} color="#7A7A7A" />
      {isHovered && (
        <>
          <TipInformationsBalloon>
            <p>{informations}</p>
          </TipInformationsBalloon>
          <TipInformationBalloonArrow>
            <TipBalloonArrowIcon />
          </TipInformationBalloonArrow>
        </>
      )}
    </TipContainer>
  );
}
